import { Routes, Route, Navigate } from "react-router-dom";
import ArticlesPage from '~/admin/pages/ArticlesPage';
import SessionPage from '~/admin/pages/SessionPage';
import CategoryPage from '~/admin/pages/CategoryPage';
import AccountPage from '~/admin/pages/AccountPage';
import StudentPage from '~/admin/pages/StudentPage';
import AdminLayout from "~/admin/components/Layout/DefaultLayout";
import DepartmentPage from "~/admin/pages/DepartmentPage";
import ClassPage from "~/admin/pages/ClassPage";
import ProfilePage from "~/admin/pages/ProfilePage";
import PrivateRoute from "../PrivateRoute";

const AdminRoutes = () => {
    return (
        <Routes>
            <Route element={<AdminLayout />}>
                <Route element={<PrivateRoute allowedRoles={['Admin', 'Staff']} />}>
                    <Route index element={<Navigate to="/admin/articles" />} />
                    <Route path="/articles" element={<ArticlesPage />} />
                    <Route path="/session" element={<SessionPage />} />
                    <Route path="/student" element={<StudentPage />} />
                    <Route path="/category" element={<CategoryPage />} />
                    <Route path="/accounts" element={<AccountPage />} />
                    <Route path="/department" element={<DepartmentPage />} />
                    <Route path="/classes" element={<ClassPage />} />
                    <Route path="/profile" element={<ProfilePage />} />
                </Route>
            </Route>
        </Routes>
    );
}

export default AdminRoutes;